export default "__VITE_ASSET__CZBsXUH6__"